import { type RefObject, useEffect } from 'react';

/** Po nieudanej walidacji przenosi fokus na pierwsze błędne pole formularza (dostępność, klawiatura). */
export function useFocusFirstInvalid(formRef: RefObject<HTMLFormElement | null>, trigger: unknown): void {
  // biome-ignore lint/correctness/useExhaustiveDependencies: celowo reagujemy tylko na zmianę błędów
  useEffect(() => {
    const target = formRef.current?.querySelector<HTMLElement>('[aria-invalid="true"]');
    target?.focus();
  }, [trigger]);
}
